// Constant Data for Merchant::Inbound::Item
export const CURATION_STATUS = {
  PENDING   : 'pending',
  COMPLETED : 'completed'
}

export const CATEGORY = {
  PAKAIAN   : 'pakaian',
  SEPATU    : 'sepatu',
  TAS       : 'tas',
  AKSESORIS : 'aksesoris',
  MAKE_UP   : 'make_up'
}

export const MERCHANT_TYPE = {
  MERCHANT_FULL : 'merchant_full',
  MERCHANT_LIST : 'merchant_list'
}

export const PAKAIAN_ATTR = {
  NO                  : 'no',
  BRAND_SKU           : 'brand_sku',
  MAIN_CATEGORY       : 'main_category',
  BRAND               : 'brand',
  COLOR               : 'color',
  PATTERN             : 'pattern',
  FABRIC              : 'fabric',
  CONDITION           : 'condition',
  PRICE               : 'price',
  PRODUCT_NAME        : 'product_name',
  QUANTITY            : 'quantity',
  SIZE                : 'size',
  CHEST_CIRCUMFERENCE : 'chest_circumference',
  TOP_LENGTH          : 'top_length',
  HIP_CIRCUMFERENCE   : 'hip_circumference',
  TOP_HIP             : 'top_hip',
  WAIST_CIRCUMFERENCE : 'waist_circumference',
  BOTTOM_LENGTH       : 'bottom_length',
  WEIGHT              : 'weight',
  NOTE                : 'note'
}

export const SEPATU_ATTR = {
  NO            : 'no',
  BRAND_SKU     : 'brand_sku',
  MAIN_CATEGORY : 'main_category',
  BRAND         : 'brand',
  COLOR         : 'color',
  PATTERN       : 'pattern',
  FABRIC        : 'fabric',
  CONDITION     : 'condition',
  PRICE         : 'price',
  PRODUCT_NAME  : 'product_name',
  QUANTITY      : 'quantity',
  SIZE_EU       : 'size_eu',
  SIZE_US       : 'size_us',
  HEEL_HEIGHT   : 'heel_height',
  BOX           : 'box',
  INSOLE        : 'insole',
  WEIGHT        : 'weight',
  NOTE          : 'note',
  MATERIAL      : 'material',
  BOX_LENGTH    : 'box_length',
  BOX_WIDTH     : 'box_width',
  BOX_HEIGHT    : 'box_height',
  DUSTBAG       : 'dustbag'

}

export const TAS_ATTR = {
  NO                : 'no',
  BRAND_SKU         : 'brand_sku',
  MAIN_CATEGORY     : 'main_category',
  BRAND             : 'brand',
  COLOR             : 'color',
  PATTERN           : 'pattern',
  MATERIAL          : 'material',
  CONDITION         : 'condition',
  PRICE             : 'price',
  PRODUCT_NAME      : 'product_name',
  QUANTITY          : 'quantity',
  LENGTH            : 'length',
  WIDTH             : 'width',
  HEIGHT            : 'height',
  BOX_LENGTH        : 'box_length',
  BOX_WIDTH         : 'box_width',
  BOX_HEIGHT        : 'box_height',
  STRAP_LENGTH      : 'strap_length',
  BAG_HANDLE_LENGTH : 'bag_handle_length',
  BOX               : 'box',
  DUSTBAG           : 'dustbag',
  CERTIFICATE       : 'certificate',
  WEIGHT            : 'weight',
  NOTE              : 'note'
}

export const AKSESORIS_ATTR = {
  NO                  : 'no',
  BRAND_SKU           : 'brand_sku',
  MAIN_CATEGORY       : 'main_category',
  BRAND               : 'brand',
  COLOR               : 'color',
  PATTERN             : 'pattern',
  FABRIC              : 'fabric',
  CONDITION           : 'condition',
  PRICE               : 'price',
  PRODUCT_NAME        : 'product_name',
  QUANTITY            : 'quantity',
  LENGTH              : 'length',
  WIDTH               : 'width',
  HEIGHT              : 'height',
  STRAP_LENGTH        : 'strap_length',
  TINY_DIAMETER       : 'tiny_diameter',
  BRIDGE_LENGTH       : 'bridge_length',
  LENS_HEIGHT         : 'lens_height',
  LENS_WIDTH          : 'lens_width',
  TEMPLE_LENGTH       : 'temple_length',
  CHAIN_LENGTH        : 'chain_length',
  DIAMETER            : 'diameter',
  WRIST_CIRCUMFERENCE : 'wrist_circumference',
  BOX                 : 'box',
  WEIGHT              : 'weight',
  NOTE                : 'note',
  MATERIAL            : 'material'
}

export const MAKE_UP_ATTR = {
  NO                  : 'no',
  BRAND_SKU           : 'brand_sku',
  MAIN_CATEGORY       : 'main_category',
  BRAND               : 'brand',
  COLOR               : 'color',
  CONDITION           : 'condition',
  PRICE               : 'price',
  PRODUCT_NAME        : 'product_name',
  QUANTITY            : 'quantity',
  MAKE_UP_SIZE        : 'make_up_size',
  MAKE_UP_FILL        : 'make_up_fill',
  MAKE_UP_EXPIRY_DATE : 'make_up_expiry_date',
  WEIGHT              : 'weight',
  SHADE               : 'shade',
  NOTE                : 'note'
}
